import EzModalController from 'layouts/modal/modal-controller';
import Cookies from 'js-cookie';
import Turbolinks from 'turbolinks';

export default class SignupEmailVerificationController extends EzModalController {
  declare emailVerificationTarget: HTMLElement;

  static targets = ['emailVerification'];

  connect() {
    super.connect();
  }

  disconnect() {
    super.disconnect();
  }

  close = (event) => {
    super.close(event, () => { /* do nothing */ }, this.dismissAfterUserClose);
  }

  dismissAfterUserClose = (event) => {
    // we only want to fire the dismiss action if the user manually closes the modal
    const element = event.currentTarget as HTMLElement;

    if (element.dataset.action.includes('signup-email-verification#close')) {
      const loginInPlace = Cookies.get('login_in_place');

      if (loginInPlace) {
        const closeEvent = new CustomEvent('LoggedInPlace');
        window.dispatchEvent(closeEvent);
      } else if (Cookies.get('reload_after_email_verification_close')) {
        Cookies.remove('reload_after_email_verification_close');

        const userId = this.emailVerificationTarget.getAttribute('data-user-id');
        Turbolinks.visit(`/signup/email_verification/dismiss/${userId}`);
      }
    }
  };
}
